// extracted by mini-css-extract-plugin
module.exports = {"container":"service-module--container--2BiCN","mainBody":"service-module--mainBody--1qsKd","mainBodyAlt":"service-module--mainBodyAlt--2QMgO"};